export interface SentryConfig {
  dsn: string;
  environment: string;
  debug: boolean;
  tracesSampleRate: number;
  replaysSessionSampleRate: number;
  replaysOnErrorSampleRate: number;
}

const resolveEnvironment = (): string => {
  const env = import.meta.env.VITE_SENTRY_ENVIRONMENT;
  if (env) return env;

  const apiUrl = import.meta.env.VITE_DMS_API || '';
  if (apiUrl.includes('localhost') || apiUrl.includes('dev') || apiUrl.includes('nightly')) return 'development';
  if (apiUrl.includes('staging-dev') || apiUrl.includes('staging')) return 'staging';
  return 'production';
};

export const isSentryEnabled = (): boolean => {
  const explicit = import.meta.env.VITE_SENTRY_ENABLED;
  if (explicit === 'false') return false;
  if (explicit === 'true') return true;
  // Enabled by default when DSN is present
  return !!import.meta.env.VITE_SENTRY_DSN;
};

export const getSentryConfig = (): SentryConfig => {
  const environment = resolveEnvironment();
  const isProduction = environment === 'production';

  return {
    dsn: import.meta.env.VITE_SENTRY_DSN || '',
    environment,
    debug: import.meta.env.VITE_SENTRY_DEBUG === 'true',
    tracesSampleRate: isProduction ? 0.2 : 1.0,
    replaysSessionSampleRate: isProduction ? 0.1 : 0.0,
    replaysOnErrorSampleRate: 1.0,
  };
};

export const logSentryConfig = (): void => {
  const config = getSentryConfig();
  console.log('[Sentry] Config:', {
    dsn: config.dsn ? `${config.dsn.substring(0, 30)}...` : 'NOT SET',
    environment: config.environment,
    debug: config.debug,
    tracesSampleRate: config.tracesSampleRate,
    replaysSessionSampleRate: config.replaysSessionSampleRate,
    replaysOnErrorSampleRate: config.replaysOnErrorSampleRate,
  });
};
